module.exports = __webpack_public_path__ + "static/media/document-white.161513ad.svg";